// Every admin route must be declared here with its meta.path, otherwise a hard
// reload on that URL can't resolve to the `admin` state and the <StateMachine.State
// is="admin"> gate in Admin/index.js renders nothing (blank screen).
const admin = {
  initial: "search",
  meta: { path: "/admin" },
  context: {},
  states: {
    login: {
      meta: { path: "/admin/login" }
    },
    search: {},
    applicationReview: {
      meta: { path: "/admin/application-review" }
    },
    results: {
      meta: { path: "/admin/results" }
    },
    model: { meta: { path: "/admin/model/:id" } },
    create: {
      meta: { path: "/admin/create" }
    },
    membersChat: {
      meta: { path: "/admin/members-chat" }
    },
    manageAgents: {
      meta: { path: "/admin/manage-agents" }
    },
    features: {
      meta: { path: "/admin/features" }
    },
    changeHistory: {
      meta: { path: "/admin/change-history" }
    }
  }
};

export default admin;
